import styled from 'styled-components'

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;

  input {
    width: 20px;
    height: 20px;
    cursor: pointer;
    border-radius: 5px;
  }

  input:checked {
    accent-color: var(--blue2);
  }

  label {
    color: #797979;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin-left: 9px;
    cursor: pointer;
  }
`
